export const getMerchantOrders = (query: string) => ({
	url: `/orders/merchant?${query}`,
	method: "GET",
});

// Admin-wide order list (all customers/merchants). Backed by the
// ROLE_ADMIN-only GET /api/v1/orders endpoint.
export const getAllOrdersURL = ({ page = 0, size = 10 }) => ({
	url: `/orders?page=${page}&size=${size}`,
	method: "GET",
});

// Admin-wide returns list. Backed by the ROLE_ADMIN GET
// /api/v1/orders/returned-items endpoint (returns every merchant's returns).
export const getAllReturnsURL = ({ page = 0, size = 10 }) => ({
	url: `/orders/returned-items?page=${page}&size=${size}`,
	method: "GET",
});

// Admin-wide refunds list. Backed by the ROLE_ADMIN GET
// /api/v1/orders/admin/refunds endpoint.
export const getAllRefundsURL = ({ page = 0, size = 10 }) => ({
	url: `/orders/admin/refunds?page=${page}&size=${size}`,
	method: "GET",
});

// Approve a customer return (ROLE_ADMIN) — triggers the refund.
export const approveReturnURL = (returnItemQueueId: string) => ({
	url: `/orders/admin/returns/${returnItemQueueId}/approve`,
	method: "PATCH",
});

// Reject a customer return (ROLE_ADMIN) — rolls back the return, no refund.
export const rejectReturnURL = (returnItemQueueId: string, reason: string) => ({
	url: `/orders/admin/returns/${returnItemQueueId}/reject`,
	method: "PATCH",
	data: { reason },
});
